// Lightweight haptic feedback helper.
// Uses the Vibration API where supported (Android browsers, Capacitor webview).
// Silent no-op on iOS Safari and other unsupported environments.

export type HapticPattern = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error';

const PATTERNS: Record<HapticPattern, number | number[]> = {
  light: 8,
  medium: 14,
  heavy: 24,
  success: [10, 30, 10],
  warning: [20, 40, 20],
  error: [30, 60, 30, 60, 30],
};

export function haptic(pattern: HapticPattern = 'light') {
  try {
    if (typeof window === 'undefined') return;
    const nav = window.navigator as Navigator & { vibrate?: (p: number | number[]) => boolean };
    if (typeof nav.vibrate === 'function') {
      nav.vibrate(PATTERNS[pattern]);
    }
  } catch {
    // ignore
  }
}
